import {
  homeContentShellSx,
  homePageBg,
  providerContentAbovePromoGapSx,
} from '@/features/home/styles/homeStyles'

export {
  providerShellHeroSx as selectBrandHeroSx,
  providerShellHeroShellSx as selectBrandHeroShellSx,
  homeHeroGreetingSx as selectBrandHeroGreetingSx,
  homeHeroWelcomeSx as selectBrandHeroWelcomeSx,
  homeContentInnerSx as selectBrandContentInnerSx,
} from '@/features/home/styles/homeStyles'

/** Figma 5181:9760 — Select a Brand (rewards redemption) */
export const selectBrandBalanceBg = 'rgba(189, 206, 255, 0.3)'
export const selectBrandBalanceBorder = '#BDCEFF'
export const selectBrandSearchBorder = '#E4E9F0'
export const selectBrandHeading = '#0F1729'
export const selectBrandMinRedeem = '#35466E'
export const selectBrandGridGapPx = 24

export const selectBrandPageRootSx = {
  bgcolor: homePageBg,
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
} as const

/** Figma 5181:8961 — 1280 shell + 40px padding, 884px inner column (same as Home / Rewards) */
export const selectBrandContentShellSx = {
  ...homeContentShellSx,
  flex: 1,
  pt: { xs: 3, md: '47px' },
  pb: 4,
} as const

export const selectBrandTitleSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 700,
  fontSize: { xs: '24px', md: '32px' },
  lineHeight: { xs: '32px', md: '40px' },
  letterSpacing: '0.4063px',
  color: selectBrandHeading,
  mb: { xs: 3, md: '35px' },
} as const

export const selectBrandSearchFieldSx = {
  mb: '18px',
  '& .MuiOutlinedInput-root': {
    height: '48px',
    borderRadius: '12px',
    bgcolor: '#FFFFFF',
    px: '19px',
    '& fieldset': {
      borderColor: selectBrandSearchBorder,
    },
    '&:hover fieldset': {
      borderColor: selectBrandSearchBorder,
    },
    '&.Mui-focused fieldset': {
      borderColor: selectBrandSearchBorder,
    },
  },
  '& .MuiOutlinedInput-input': {
    fontSize: '15px',
    fontFamily: '"Inter", sans-serif',
    color: '#0D1B2A',
    '&::placeholder': {
      color: 'rgba(13, 27, 42, 0.5)',
      opacity: 1,
    },
  },
} as const

export const selectBrandBalanceCardSx = {
  width: '100%',
  border: `1px solid ${selectBrandBalanceBorder}`,
  bgcolor: selectBrandBalanceBg,
  borderRadius: '12px',
  p: { xs: 2, md: '25px' },
  minHeight: { xs: 'auto', md: '121px' },
  mb: '32px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 2,
  boxSizing: 'border-box',
} as const

export const selectBrandBalanceAmountSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 700,
  fontSize: { xs: '24px', md: '32px' },
  lineHeight: { xs: '32px', md: '40px' },
  letterSpacing: '0.4063px',
  color: '#008CD0',
} as const

export const selectBrandBalanceMinSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '19.6px',
  letterSpacing: '0.14px',
  color: selectBrandMinRedeem,
  mt: '3px',
} as const

export const selectBrandBalanceIconSx = {
  width: 100,
  height: 100,
  objectFit: 'contain' as const,
  flexShrink: 0,
  display: { xs: 'none', sm: 'block' },
} as const

export const selectBrandLogoSx = {
  width: 56,
  height: 54,
  borderRadius: '8px',
} as const

export const selectBrandLogoPlaceholderSx = {
  width: 56,
  height: 54,
  borderRadius: '8px',
  bgcolor: '#e6ecff',
  border: '1px solid #bdceff',
  flexShrink: 0,
} as const

export const selectBrandCardSx = {
  width: '100%',
  minWidth: 0,
  height: 'auto',
  bgcolor: '#FFFFFF',
  border: '1px solid #E8EDF2',
  borderRadius: '16px',
  boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.05)',
  p: '18px',
  minHeight: '196px',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
} as const

export const selectBrandCardTitleSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '28px',
  letterSpacing: '-0.4492px',
  color: '#0D1B2A',
  pt: '16px',
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
} as const

export const selectBrandCardDescriptionSx = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '13px',
  lineHeight: '19.5px',
  color: '#6B7A90',
} as const

export const selectBrandCardDescriptionClampedSx = {
  ...selectBrandCardDescriptionSx,
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
} as const

export const selectBrandCardReadMoreSx = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '13px',
  lineHeight: '19.5px',
  fontWeight: 600,
  color: '#008CD0',
  p: 0,
  mt: '4px',
  minWidth: 0,
  alignSelf: 'flex-start',
  textTransform: 'none',
  textDecoration: 'none',
  cursor: 'pointer',
  border: 'none',
  bgcolor: 'transparent',
  '&:hover': {
    textDecoration: 'underline',
    bgcolor: 'transparent',
  },
} as const

export const selectBrandCardSelectButtonSx = {
  bgcolor: '#008CD0',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '21px',
  borderRadius: '10px',
  height: '44px',
  '&:hover': { bgcolor: '#007AB8' },
} as const

const selectBrandGridColumnCountSm = 2
const selectBrandGridColumnCountMd = 3
const selectBrandGridGapTotalSmPx =
  selectBrandGridGapPx * (selectBrandGridColumnCountSm - 1)
const selectBrandGridGapTotalMdPx =
  selectBrandGridGapPx * (selectBrandGridColumnCountMd - 1)

/** Three columns + gaps span the same width as the balance card (100% of inner column) */
export const selectBrandGridSx = {
  display: 'grid',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  gridTemplateColumns: {
    xs: 'minmax(0, 1fr)',
    sm: `repeat(${selectBrandGridColumnCountSm}, minmax(0, calc((100% - ${selectBrandGridGapTotalSmPx}px) / ${selectBrandGridColumnCountSm})))`,
    md: `repeat(${selectBrandGridColumnCountMd}, minmax(0, calc((100% - ${selectBrandGridGapTotalMdPx}px) / ${selectBrandGridColumnCountMd})))`,
  },
  gap: `${selectBrandGridGapPx}px`,
  alignItems: 'start',
  ...providerContentAbovePromoGapSx,
} as const
